import React, { useEffect, useState } from "react";
import PermissionCategoriesList from "./components/PermissionCategoriesList";
import PermissionAssignmentsList from "./components/PermissionAssignmentsList";
import { PageLink, PageTitle } from "_metronic/layout/core";
import { Permission } from "services/userSession/UserPermittedComponent";
import { Permissions } from "cpl-react-common/components/Enums/Permissions";
import { PermissionCategoryModel } from "services/api/cplauthapi/CPLAuthAPI";
import { useSelector } from "react-redux";
import { selectPermissionCategories } from "./components/PermissionCategoriesSlice";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "setup/appInsights/ApplicationInsightsService";

const permissionBreadCrumbs: Array<PageLink> = [
  {
    title: "Permissions",
    path: "/Admin/Permissions",
    isSeparator: false,
    isActive: true,
  },
];

const UserPermissionPage: React.FC = () => {
  const permissionCategories = useSelector(selectPermissionCategories);
  const [permissionCategory, updatePermissionCategory] = useState<PermissionCategoryModel>(permissionCategories[0]);

  useEffect(() => {
    updatePermissionCategory(permissionCategories[0]);
  }, [permissionCategories]);

  return (
    <Permission permissionPredicate={(permission) => permission === Permissions.ViewPermissions}>
      <CPLAnalytics pageName="Permissions Matrix">
        <PageTitle breadcrumbs={permissionBreadCrumbs}></PageTitle>
        <div className="row">
          <div className="col-sm-3 col-md-2">
            <PermissionCategoriesList />
          </div>
          <div className="col-sm-9 col-md-10">{permissionCategory !== undefined && <PermissionAssignmentsList />}</div>
        </div>
      </CPLAnalytics>
    </Permission>
  );
};
export default withAITracking(reactPlugin, UserPermissionPage, "Permissions Matrix");
